import React from 'react';
import { NumberService } from 'Services';
import { EllipsisText } from '@brighterion/br-ui';
import clsx from 'clsx';
import _ from 'lodash';
import TwoDashes from 'Components/TwoDashes';
import styles from './DashOrEllipText.css';

type Props = {
    rawValue: number | string;
    bold?: boolean;
};

const DashOrEllipText = ({ rawValue, bold }: Props) => {
    // convert numbers and booleans to strings so they aren't registered as falsy
    let coercedValue = rawValue;

    if (_.isNumber(rawValue)) {
        coercedValue = NumberService.getLocaleNumber(rawValue);
    }
    if (_.isBoolean(rawValue)) {
        coercedValue = String(rawValue);
    }
    if (!coercedValue) {
        return (
            <span>
                <TwoDashes bold={bold} />
            </span>
        );
    }

    return (
        <EllipsisText
            text={coercedValue as string}
            showArrows={false}
            popoverProps={{
                content: coercedValue as string,
                position: 'bottom-end',
                showArrow: false,
                showCopy: false,
                popperClassName: styles.ellipsisPopOver
            }}
            className={clsx(styles.ellipsisText, bold && styles.bold)}
        />
    );
};

export default DashOrEllipText;
